import React, { useEffect, useState } from "react";
import _ from "underscore";

import '../../assets/css/common.css';
import '../../assets/css/sidemenu.css';
import '../../assets/css/timesheet.css';

import NavBar from "../../components/nav-bar";
import SideBar from "../../components/sidebar";

import CollapsibleTable from "./collapsible-table";

function Routing() {
    const [orderData, setOrderData] = useState([]);
    const [inventoryData, setInventoryData] = useState([]);
    const [vendorData, setVendorData] = useState([]);
    const [vehicleData, setVehicleData] = useState([]);
    const [routingData, setRoutingData] = useState([]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/orders`)
            .then(response => response.json())
            .then(json => setOrderData(json))
            .catch(error => console.error(error));

        fetch(`${process.env.REACT_APP_API_URL}/fg_inventory`)
            .then(response => response.json())
            .then(json => setInventoryData(json))
            .catch(error => console.error(error));

        fetch(`${process.env.REACT_APP_API_URL}/vendors`)
            .then(response => response.json())
            .then(json => {
                var vehicles = _.flatten(_.pluck(json, 'vehicles'));
                setVendorData(json);
                setVehicleData(vehicles)
            })
            .catch(error => console.error(error));
    }, [])

    useEffect(() => {
        if (orderData.length > 0 && inventoryData.length > 0 && vehicleData.length > 0) {
            fetch(`${process.env.REACT_APP_MODEL_API_URL}/logistics`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "customers": orderData,
                    "inventory": inventoryData,
                    "vehicles": vehicleData
                })
            })
                .then(response => response.json())
                .then(json => setRoutingData(json))
                .catch(error => console.error(error));
        }
    }, [orderData, inventoryData, vehicleData])

    return (
        <div className="container-fluid px-0 mb-5">
            <main id="main-layout" role="main" className="pb-3">
                <div className="enquiry-page-wrapper">
                    <NavBar title={"Routing"} />
                    <div className="container-fluid">
                        <div className="row">
                            <SideBar />

                            <div className="home-section">
                                <div className="col-lg-12 mb-2 pb-2" id="logContainer">
                                    {/* <div className="row m-0 justify-content-between align-items-center">
                                        <div className="card-header p-0" style={{ borderBottom: "none" }}>
                                            <ul className="nav nav-tabs justify-content-start common-view-tabs" role="tablist">
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link active common-view-link" data-status-id="0"
                                                        id="nav-Current-tab" data-toggle="tab" href="#nav-Current"
                                                        role="tab" aria-controls="nav-Current"
                                                        aria-selected="true">Scheduler</a>
                                                </li>
                                                <li className="nav-item common-view-item">
                                                    <a className="nav-link common-view-link" data-status-id="1"
                                                        id="nav-History-tab" data-toggle="tab" href="#nav-History"
                                                        role="tab" aria-controls="nav-History"
                                                        aria-selected="true">History</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6 top-right d-flex justify-content-end align-items-end"
                                            style={{ gap: "10px" }}>
                                            <div className="container-fluid">
                                                <input className="Enquiry-form-control" type="search" id="searchInput"
                                                    placeholder="Search by Process" />
                                            </div>
                                            <div className="d-flex" style={{ gap: "10px" }}>
                                                <div>
                                                    <a role="button" className="c-black" href="/temp/Production Schedule.xlsx"
                                                        title="Download Report">
                                                        <i className="f-24 i-btn cursor-pointer ti ti-download"></i>
                                                    </a>
                                                </div>
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip"
                                                    title="Filter" onClick="openSideFilterPanel()">
                                                    <i id="filter-icon" className="f-24 i-btn cursor-pointer ti ti-filter"></i>
                                                </a>
                                            </div>
                                            <div id="plan-insert-record">
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip" title="Add"
                                                    onClick="insertRowSchedule()">
                                                    <i className="f-24 i-btn cursor-pointer ti ti-table-plus"></i>
                                                </a>
                                            </div>
                                            <div id="plan-upload-record">
                                                <input type="file" id="excelFileInput" accept=".xlsx, .xls"
                                                    style={{ display: "none" }} onchange="excelFileUpload()" />
                                                <a role="button" href="#" className="c-black" data-toggle="tooltip"
                                                    title="Upload"
                                                    onClick="document.getElementById('excelFileInput').click();">
                                                    <i className="f-24 i-btn cursor-pointer ti ti-upload"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="tab-content mt-1" id="nav-tabContent">
                                        <div className="tab-pane fade show active" id="nav-Current" role="tabpanel"
                                            aria-labelledby="nav-Current-tab">
                                            <div id="list_content" className="table-responsive">
                                                {/* <table className="table-list table-hover schedule-table" style={{ width: "100%" }}
                                                    id="plan-schedule-table">
                                                    <thead>
                                                        <tr className="table-list-header-row" style={{ color: "#ffffff" }}>
                                                            <th>Order Id</th>
                                                            <th>Product SKU</th>
                                                            <th>Order Qty</th>
                                                            <th>Plant Code</th>
                                                            <th>Available Stock</th>
                                                            <th>Supplied Qty</th>
                                                            <th>Vehicle Number</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="table-list-body">
                                                        {routingData?.logistic_data?.map((dt, i) =>
                                                            <>
                                                                <tr className="table-list-body-row collapse plan-schedule-row show"
                                                                    id={`row-` + i} key={i} data-id="1">
                                                                    <td data-type="text" name="order_id">
                                                                        {dt.customer.order_no}
                                                                    </td>
                                                                    <td data-type="text" name="product_sku">{dt.customer.product_sku}</td>
                                                                    <td data-type="text" name="order_qty">{dt.customer.order_qty}</td>
                                                                    <td colspan="4"></td>
                                                                </tr>
                                                                {dt?.plants?.map((dt1, i) =>
                                                                    <>
                                                                        <tr className="table-list-body-row collapse plan-schedule-row show"
                                                                            id={`row-` + i} key={i} data-id="1">
                                                                            <td colspan="3"></td>
                                                                            <td data-type="text" name="plant_code">{dt1.plant_code}</td>
                                                                            <td data-type="text" name="available_stock">{dt1.available_stock}</td>
                                                                            <td data-type="text" name="units">{dt1.supplied_units}</td>
                                                                            <td data-type="text" name="vehicle_number">
                                                                                <a href={`/routing-map?cus=${dt?.customer?.location?.lat},${dt?.customer?.location?.lng}&plt=${dt1?.plant?.location?.lat},${dt1?.plant?.location?.lng}&veh=${dt?.vehicle?.location?.lat},${dt?.vehicle?.location?.lng}`}>
                                                                                    {dt?.vehicle?.vehicle_number}
                                                                                </a>
                                                                            </td>
                                                                        </tr>
                                                                    </>)}
                                                            </>)}
                                                    </tbody>
                                                </table> */}
                                                <CollapsibleTable data={routingData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
export default Routing;